import { PatientGoal } from "./patient_goal_class";
import { EducationLinkShape } from "../interfaces/classTypes";

export class PatientGoalEducation extends PatientGoal {
  public educationLinkIds: string | null;
  public educationLinks: EducationLinkShape[];

  constructor({
    achievementCondition,
    achievementProgress,
    achievementTarget,
    achievementTargetFormatted,
    achievementThreshold,
    active,
    continuous,
    createdAt,
    deactivatedAt,
    description,
    endDateFormatted,
    goalTemplate,
    goalTypeSpecifics,
    id,
    leaderboardEnabled,
    leaderboardIncluded,
    monitorProfileId,
    name,
    occurrenceAmount,
    occurrenceFrequency,
    startDateFormatted,
    type,
    updatedAt,
  }: any) {
    let extendedData = {
      achievementCondition: achievementCondition,
      achievementProgress: achievementProgress,
      achievementTarget: achievementTargetFormatted
        ? achievementTargetFormatted
        : achievementTarget,
      achievementThreshold: achievementThreshold,
      active: active,
      continuous: continuous,
      createdAt: createdAt,
      deactivatedAt: deactivatedAt,
      description: description,
      endDate: endDateFormatted,
      goalTemplateId: goalTemplate.id,
      id: id,
      leaderboardEnabled: leaderboardEnabled,
      leaderboardIncluded: leaderboardIncluded,
      monitorProfileId: monitorProfileId,
      name: name,
      occurrenceAmount: occurrenceAmount,
      occurrenceFrequency: occurrenceFrequency,
      startDate: startDateFormatted,
      type: type,
      updatedAt: updatedAt,
    };

    super(extendedData);
    this.educationLinkIds = goalTypeSpecifics;
    this.educationLinks = this.goalTemplate.selectedEducationLinks;
  }
}
